var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 6.79803H16.5V4.79803C16.5 3.69803 15.6 2.79803 14.5 2.79803H10.5C9.4 2.79803 8.5 3.69803 8.5 4.79803V6.79803H4.5C3.4 6.79803 2.5 7.69803 2.5 8.79803V20.798C2.5 21.898 3.4 22.798 4.5 22.798H20.5C21.6 22.798 22.5 21.898 22.5 20.798V8.79803C22.5 7.69803 21.6 6.79803 20.5 6.79803ZM10.5 4.79803H14.5V6.79803H10.5V4.79803ZM20.5 20.798H4.5V8.79803H20.5V20.798Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5 10.798H11.5V13.798H8.5V15.798H11.5V18.798H13.5V15.798H16.5V13.798H13.5V10.798Z",
    fill: "#14AA3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario7);
export default __webpack_public_path__ + "static/media/Scenario7.5cc1fb3334bbb4057456103fea611693.svg";
export { ForwardRef as ReactComponent };